import { useState, useMemo } from "react";
import { Card, Table, Pagination, Form } from "react-bootstrap";
import { Link } from "react-router-dom";

const DUMMY_DATA = [
    { id: 1, userId: "USR-1042", name: "Arjun Mehta", amount: 4500.00, charges: 22.50, walletType: "Crypto", status: "Completed", date: "2025-06-01" },
    { id: 2, userId: "USR-2187", name: "Priya Sharma", amount: 1200.00, charges: 6.00, walletType: "Bank", status: "Pending", date: "2025-06-01" },
    { id: 3, userId: "USR-3390", name: "Rohan Kapoor", amount: 8750.50, charges: 43.75, walletType: "PayPal", status: "Completed", date: "2025-05-31" },
    { id: 4, userId: "USR-4001", name: "Sneha Iyer", amount: 320.00, charges: 1.60, walletType: "Card", status: "Failed", date: "2025-05-31" },
    { id: 5, userId: "USR-5522", name: "Vikram Nair", amount: 15000.00, charges: 75.00, walletType: "Bank", status: "Completed", date: "2025-05-30" },
    { id: 6, userId: "USR-6733", name: "Ananya Roy", amount: 2300.75, charges: 11.50, walletType: "Crypto", status: "Pending", date: "2025-05-30" },
    { id: 7, userId: "USR-7841", name: "Karan Singh", amount: 550.00, charges: 2.75, walletType: "PayPal", status: "Completed", date: "2025-05-29" },
    { id: 8, userId: "USR-8102", name: "Meera Joshi", amount: 9800.00, charges: 49.00, walletType: "Card", status: "Completed", date: "2025-05-29" },
    { id: 9, userId: "USR-9240", name: "Deepak Verma", amount: 420.25, charges: 2.10, walletType: "Bank", status: "Failed", date: "2025-05-28" },
    { id: 10, userId: "USR-1034", name: "Lakshmi Pillai", amount: 6700.00, charges: 33.50, walletType: "Crypto", status: "Completed", date: "2025-05-28" },
];

const fmtCurrency = (v) =>
    new Intl.NumberFormat("en-US", { style: "currency", currency: "USD" }).format(v);

const statusClass = (s) => ({ Completed: "ft-status-completed", Pending: "ft-status-pending", Failed: "ft-status-failed" }[s] || "ft-status-pending");

const walletClass = (w) => ({ Crypto: "ft-wallet-crypto", Bank: "ft-wallet-bank", PayPal: "ft-wallet-paypal", Card: "ft-wallet-card" }[w] || "ft-wallet-bank");

const walletIcon = (w) => ({ Crypto: "ti-currency-bitcoin", Bank: "ti-building-bank", PayPal: "ti-brand-paypal", Card: "ti-credit-card" }[w] || "ti-wallet");

const today = new Date();
const todayStr = today.toISOString().slice(0, 10);

const yesterdayStr = new Date(today - 86400000).toISOString().slice(0, 10);

const weekStart = new Date(today);


weekStart.setDate(today.getDate() - today.getDay());

const monthStart = new Date(today.getFullYear(), today.getMonth(), 1);

const sumFor = (rows) => rows.reduce((a, r) => a + r.amount, 0);

const FILTER_BADGES = [
    { label: "All", value: "all" },
    { label: "Completed", value: "Completed" },
    { label: "Pending", value: "Pending" },
    { label: "Failed", value: "Failed" },
];

const WALLET_BADGES = [
    { label: "All Wallets", value: "all" },
    { label: "Crypto", value: "Crypto" },
    { label: "Bank", value: "Bank" },
    { label: "PayPal", value: "PayPal" },
    { label: "Card", value: "Card" },
];

export default function FundTransfer() {

    const [search, setSearch] = useState("");
    const [page, setPage] = useState(1);
    const [rowsPerPage, setRPP] = useState(5);
    const [sortKey, setSortKey] = useState("date");
    const [sortDir, setSortDir] = useState("desc");
    const [statusFilter, setStatusFilter] = useState("all");
    const [walletFilter, setWalletFilter] = useState("all");


    const todayAmt = sumFor(DUMMY_DATA.filter((r) => r.date === todayStr));
    const yestAmt = sumFor(DUMMY_DATA.filter((r) => r.date === yesterdayStr));

    const weekAmt = sumFor(DUMMY_DATA.filter((r) => new Date(r.date) >= weekStart));
    const monthAmt = sumFor(DUMMY_DATA.filter((r) => new Date(r.date) >= monthStart));
    const allAmt = sumFor(DUMMY_DATA);

    const STAT_CARDS = [
        { label: "Today", value: todayAmt, accent: "#00c8ff", badge: "+0%", badgeBg: "rgba(0,200,255,0.1)", badgeColor: "#007a99" },
        { label: "Yesterday", value: yestAmt, accent: "#00d68f", badge: "↑ 3.2%", badgeBg: "rgba(0,214,143,0.12)", badgeColor: "#007a56" },
        { label: "This Week", value: weekAmt, accent: "#ffb347", badge: "↑ 8.5%", badgeBg: "rgba(255,179,71,0.12)", badgeColor: "#a36800" },
        { label: "This Month", value: monthAmt, accent: "#ff5c74", badge: "↑ 12.1%", badgeBg: "rgba(255,92,116,0.12)", badgeColor: "#b5001f" },
        { label: "All Time", value: allAmt, accent: "#8b5cf6", badge: "Total", badgeBg: "rgba(139,92,246,0.1)", badgeColor: "#5b21b6" },
    ];

    const handleSort = (key) => {
        if (sortKey === key) setSortDir((d) => (d === "asc" ? "desc" : "asc"));
        else { setSortKey(key); setSortDir("asc"); }
        setPage(1);
    };

    const filtered = useMemo(() => {

        const q = search.toLowerCase();

        return DUMMY_DATA.filter((r) => {
            const matchSearch =

                r.name.toLowerCase().includes(q) ||

                r.userId.toLowerCase().includes(q) ||

                r.status.toLowerCase().includes(q) ||

                r.walletType.toLowerCase().includes(q);

            const matchStatus = statusFilter === "all" || r.status === statusFilter;

            const matchWallet = walletFilter === "all" || r.walletType === walletFilter;

            return matchSearch && matchStatus && matchWallet;
        });
    }, [search, statusFilter, walletFilter]);

    // usememo
    const sorted = useMemo(() => {

        return [...filtered].sort((a, b) => {
            let av = a[sortKey], bv = b[sortKey];

            if (typeof av === "string") { av = av.toLowerCase(); bv = bv.toLowerCase(); }

            if (av < bv) return sortDir === "asc" ? -1 : 1;

            if (av > bv) return sortDir === "asc" ? 1 : -1;
            return 0;
        });

    }, [filtered, sortKey, sortDir]);

    const totalPages = Math.max(1, Math.ceil(sorted.length / rowsPerPage));
    const safePage = Math.min(page, totalPages);
    const pageRows = sorted.slice((safePage - 1) * rowsPerPage, safePage * rowsPerPage);
    const startIdx = (safePage - 1) * rowsPerPage + 1;
    const paginationNums = () => {
        const nums = [];

        const delta = 1;

        for (let i = 1; i <= totalPages; i++) {
            if (i === 1 || i === totalPages || (i >= safePage - delta && i <= safePage + delta)) {
                nums.push(i);
            } else if (nums[nums.length - 1] !== "...") {
                nums.push("...");
            }
        }
        return nums;
    };

    const SortIcon = ({ col }) => (

        <span className={`ft-sort-icon ${sortKey === col ? "active" : ""}`}>

            {sortKey === col ? (sortDir === "asc" ? "▲" : "▼") : "⇅"}
        </span>
    );

    return (
        <>

            <div className="breadcrumb-bar mb-2 mx-1" >
                <div className="container-fluid">
                    <div className="d-flex  flex-row align-items-center justify-content-between gap-2 py-2">

                        <div className="breadcrumb-left d-flex align-items-center flex-wrap">
                            <Link to="/admin/home" className="breadcrumb-link active my-2">
                                Home
                            </Link>

                            <span className="breadcrumb-separator mx-2">
                                <i className="bi bi-chevron-right"></i>
                            </span>

                            <span
                                className="breadcrumb-link inactive"
                            // onClick={() => navigate("/admin/projectlist")}
                            >
                                Fund transfer summary
                            </span>

                        </div>

                        {/* <button
                            className="add-outlet-btn"
                            onClick={() => navigate("/admin/projects")}
                        >

                            Projectlist
                        </button> */}

                    </div>
                </div>
            </div>

            <div className="ft-root px-3 mt-4">
                <div className="ft-header">
                    <div className="ft-header-icon">
                        <i className="ti ti-arrows-transfer-up" aria-hidden="true" />
                    </div>
                    <div>
                        <div className="ft-header-title"> User Fund Transfer Summary</div>

                    </div>
                </div>

                <div className="ft-stat-grid">

                    {STAT_CARDS.map((c) => (

                        <div key={c.label} className="ft-stat-card" style={{ "--card-accent": c.accent }}>

                            <div className="ft-stat-label">{c.label}</div>

                            <div className="ft-stat-value" style={{ "--value-color": c.accent }}>{fmtCurrency(c.value)}</div>
                            <div className="ft-stat-badge" style={{ background: c.badgeBg, color: c.badgeColor }}>{c.badge}</div>

                        </div>
                    ))}
                </div>

                <div className="ft-section-head">
                    <div className="ft-section-title">
                        <i className="ti ti-history" aria-hidden="true" style={{ color: "var(--sky-blue)", fontSize: 18 }} />
                        User Fund Transfer History
                        <div className="ft-section-line" />
                    </div>
                </div>

                <div className="ft-controls-wrap">
                    <div className="ft-filter-row">
                        <div className="ft-filter-group">
                            <span className="ft-filter-label">Status</span>
                            <div className="ft-badge-group">
                                {FILTER_BADGES.map((b) => (
                                    <button
                                        key={b.value}

                                        className={`ft-filter-badge ${statusFilter === b.value ? "active" : ""}`}

                                        onClick={() => { setStatusFilter(b.value); setPage(1); }}
                                    >
                                        {b.label}
                                    </button>
                                ))}
                            </div>
                        </div>
                        <div className="ft-filter-group">
                            <span className="ft-filter-label">Wallet</span>
                            <div className="ft-badge-group">
                                {WALLET_BADGES.map((b) => (
                                    <button
                                        key={b.value}


                                        className={`ft-filter-badge ${walletFilter === b.value ? "active" : ""}`}

                                        onClick={() => { setWalletFilter(b.value); setPage(1); }}
                                    >
                                        {b.label}
                                    </button>
                                ))}
                            </div>
                        </div>
                    </div>

                    <div className="ft-toolbar">
                        <div className="ft-export-btns">
                            <button className="ft-exp-btn ft-exp-copy">Copy</button>

                            <button className="ft-exp-btn ft-exp-csv">CSV</button>

                            <button className="ft-exp-btn ft-exp-xl">Excel</button>
                            <button className="ft-exp-btn ft-exp-pdf">PDF</button>

                            <button className="ft-exp-btn ft-exp-print">Print</button>
                            <Form.Select
                                className="ft-rows-select"
                                value={rowsPerPage}
                                onChange={(e) => { setRPP(Number(e.target.value)); setPage(1); }}
                            >
                                {[5, 10, 15].map((n) => (
                                    <option key={n} value={n}>{n} / page</option>
                                ))}
                            </Form.Select>
                        </div>

                        <div className="ft-search-wrap">
                            <i className="ti ti-search ft-search-icon" aria-hidden="true" />
                            <Form.Control
                                type="text"
                                placeholder="Search by name, ID, status..."
                                value={search}
                                onChange={(e) => { setSearch(e.target.value); setPage(1); }}
                            />
                        </div>
                    </div>
                </div>

                <Card className="ud-table-card">
                    <Card.Body className="p-0">
                        <div className="ud-scroll-wrap">
                            <Table hover borderless className="ud-table align-middle mb-0">
                                <thead>
                                    <tr>
                                        <th onClick={() => handleSort("id")}>
                                            <div className="ft-th-inner">Sr No <SortIcon col="id" /></div>
                                        </th>

                                        <th onClick={() => handleSort("name")}>
                                            <div className="ft-th-inner">User <SortIcon col="name" /></div>
                                        </th>

                                        <th onClick={() => handleSort("amount")}>
                                            <div className="ft-th-inner">Amount ($) <SortIcon col="amount" /></div>
                                        </th>

                                        <th onClick={() => handleSort("charges")}>
                                            <div className="ft-th-inner">Charges ($) <SortIcon col="charges" /></div>
                                        </th>

                                        <th>
                                            <div className="ft-th-inner">Net Amount ($)</div>
                                        </th>

                                        <th onClick={() => handleSort("walletType")}>
                                            <div className="ft-th-inner">Wallet <SortIcon col="walletType" /></div>
                                        </th>
                                        <th onClick={() => handleSort("status")}>
                                            <div className="ft-th-inner">Status <SortIcon col="status" /></div>
                                        </th>
                                        <th onClick={() => handleSort("date")}>
                                            <div className="ft-th-inner">Date <SortIcon col="date" /></div>
                                        </th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {pageRows.length === 0 ? (
                                        <tr>
                                            <td colSpan={8} className="awd-empty-state">
                                                <i className="ti ti-database-off" style={{ fontSize: 28, display: "block", marginBottom: 8, color: "var(--text-light)" }} />
                                                No data available
                                            </td>
                                        </tr>
                                    ) : (
                                        pageRows.map((row, idx) => {
                                            const net = row.amount - row.charges;

                                            return (

                                                <tr key={row.id}>
                                                    <td style={{ fontWeight: 700, color: "var(--text-light)", fontSize: "0.78rem" }}>
                                                        {startIdx + idx}
                                                    </td>

                                                    <td>
                                                        <div className="ud-user-cell d-flex flex-column">
                                                            <span className="ud-user-name">{row.name}</span>
                                                            <div className="ft-user-id">{row.userId}</div>
                                                        </div>
                                                    </td>
                                                    <td className="ft-amount">{fmtCurrency(row.amount)}</td>

                                                    <td className="ft-charge">−{fmtCurrency(row.charges)}</td>

                                                    <td className="ft-net">{fmtCurrency(net)}</td>
                                                    <td>
                                                        <span className={`ft-wallet-pill ${walletClass(row.walletType)}`}>
                                                            <i className={`ti ${walletIcon(row.walletType)}`} style={{ fontSize: 12 }} aria-hidden="true" />
                                                            {row.walletType}
                                                        </span>
                                                    </td>
                                                    <td>

                                                        <span className={`ft-status-pill ${statusClass(row.status)}`}>
                                                            <span className="ft-status-dot" />
                                                            {row.status}
                                                        </span>
                                                    </td>
                                                    <td className="ft-date">{row.date}</td>
                                                </tr>
                                            );
                                        })
                                    )}
                                </tbody>
                            </Table>
                        </div>
                    </Card.Body>
                </Card>

                <div className="ud-pagination-wrap">
                    <Pagination className="ud-pagination mb-0">

                        <Pagination.Prev disabled={safePage === 1} onClick={() => setPage((p) => p - 1)} />

                        {paginationNums().map((n, i) =>

                            n === "..." ? (
                                <Pagination.Ellipsis key={`ellipsis-${i}`} disabled />
                            ) : (
                                <Pagination.Item key={n} active={safePage === n} onClick={() => setPage(n)}>
                                    {n}
                                </Pagination.Item>
                            )
                        )}

                        <Pagination.Next disabled={safePage === totalPages} onClick={() => setPage((p) => p + 1)} />

                    </Pagination>
                </div>
            </div>
        </>
    );
}